import { FC, PropsWithChildren } from 'react';
import Hidden from '@/components/Hidden';
import NoSSR from '@/components/NoSSR';
import { LeftSidebarPortalPlaceholder } from './components/LeftSidebar';
import RightSidebar from './components/RightSidebar';
import { SuggestionMenu } from './components/SuggestionMenu';
import { TopContentPortalPlaceholder } from './components/TopContent';

interface IBaseLayoutProps {
  hideSideBar?: boolean;
}

const BaseLayout: FC<PropsWithChildren<IBaseLayoutProps>> = ({
  children,
  hideSideBar = false,
}) => {
  return (
    <>
      <div className="bg-gray-10 page-full" id="__main">
        <div className="mx-auto flex min-h-full flex-row-reverse justify-center gap-6 lg:container md:!px-5 md:!py-4">
          {!hideSideBar && (
            <Hidden down="md">
              <div className="w-[216px]">
                <LeftSidebarPortalPlaceholder />
              </div>
            </Hidden>
          )}
          <NoSSR>
            <div className="min-h-full w-full overflow-hidden md:!w-[calc(100%-322px-3rem)] md:!max-w-[480px] lg:!w-[calc(100%-432px-3rem)]">
              <TopContentPortalPlaceholder />
              {children}
            </div>
            {!hideSideBar && (
              <Hidden down="md">
                <div className="w-[106px] lg:!w-[216px]">
                  <RightSidebar />
                  <SuggestionMenu />
                </div>
              </Hidden>
            )}
          </NoSSR>
        </div>
      </div>
    </>
  );
};

export default BaseLayout;
